import React from "react";

import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./index.css";
import { store } from "store/store";
import { ConfigProvider } from "antd";
import { initSentry, Sentry } from "./sentry";

initSentry();

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const container = document.getElementById("root")!;
const root = createRoot(container);

root.render(
  <Sentry.ErrorBoundary
    fallback={({ error, resetError }) => (
      <div style={{ padding: 24, textAlign: "center" }}>
        <h2>Something went wrong</h2>
        <p style={{ color: "#666", marginBottom: 16 }}>
          {error instanceof Error ? error.message : "An unexpected error occurred."}
        </p>
        <button type="button" onClick={resetError}>
          Try again
        </button>
      </div>
    )}
  >
    <ConfigProvider
      theme={{
        token: {
          // Seed Token
          colorPrimary: '#7F56D9',
        },
      }}
    >
      <Provider store={store}>
        <App />
      </Provider>
    </ConfigProvider>
  </Sentry.ErrorBoundary>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// eslint-disable-next-line no-console
reportWebVitals(console.log);
